import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Fragment } from "react";
import { Menu, Popover, Transition } from "@headlessui/react";
import { MenuIcon } from "@heroicons/react/outline";
import { ChevronDownIcon } from "@heroicons/react/solid";
import logo from "../../assets/svg/LogoNetuno_Blanco.svg";
import logoBlack from "../../assets/svg/LogoNetuno.svg";
import { Link } from "react-router-dom";
import { UseContextApp } from "../../Global/Context/appContext";
import { useEffect, useState } from "react";
import "../../index.css";
import AuthController from "../../controllers/AuthController";
import {
  menuResposive,
  menuResponsiveCorporativo,
  pagosResidecial,
  pagosEmpresarial,
  reportes,
  servicios,
  serviciosComporativo,
  facturas,
} from "../../propsType/Header/MenuHeader";
import { colors } from "../../propsType/Colors";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Header = ({
  exit,
  openModalServicios,
  openModalPagos,
  openModalReportes,
  openModalFacturas,
  openModalPerfil,
  openModalResponsive,
  responsive,
  showServicios,
  showPagos,
  showReportes,
  showProfile,
  showFacturas,
  loading,
}) => {
  const [{ user, consumoData }] = UseContextApp();
  return (
    <Popover
      className={`relative bg-[${colors.darkBlue}] z-50 `}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`flex md:grid  grid-cols-4 place-content-between   border-[${colors.darkBlue}] py-6 md:justify-start md:space-x-10`}
        >
          <div className="flex justify-start ">
            {loading ? (
              <>

                <div className="relative animate-pulse m-0 flex items-center col-span-2">
                  <li className=" h-8 rounded-md w-[154px] ! bg-gray-200 dark:bg-gray-600  "></li>
                </div>
              </>
            ) : (
              <>
                <a href="https://www.netuno.net/">
                  <span className="sr-only">Workflow</span>
                  <img className="h-8 w-auto sm:h-10" src={logo} alt="" /></a>
              </>
            )}
          </div>
          {loading ? (
            <>
              <div className="relative w-[90%] !m-0 flex items-center col-span-2">
                <div className="w-[100%] animate-pulse  flex justify-between  gap-2 items-center">
                  <li className="w-full h-4 rounded-md bg-gray-200 dark:bg-gray-600  "></li>
                  <li className="w-full h-4 rounded-md bg-gray-200 dark:bg-gray-600  "></li>
                  <li className="w-full h-4 rounded-md bg-gray-200 dark:bg-gray-600  "></li>
                  <li className="w-full h-4 rounded-md bg-gray-200 dark:bg-gray-600  "></li>
                </div>
              </div>
            </>
          ) : (
            <>
              <Popover.Group
                as="nav"
                className="hidden md:flex !m-0 items-center space-x-10"
              >
                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        onClick={openModalServicios}
                        className={classNames(
                          open ? "text-white" : "text-white",
                          "group bg-transparent rounded-md inline-flex items-center text-base font-medium  "
                        )}
                      >
                        <span>Servicios</span>
                        <ChevronDownIcon
                          className={classNames(
                            open ? "text-white" : "text-white",
                            "ml-2 h-5 w-5 "
                          )}
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        show={showServicios}
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel
                          static
                          className="absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                        >
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden totomodal">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {user?.datos?.tipoCliente === "Empresa" ? (
                                <>
                                  {serviciosComporativo.map((item) => (
                                    <Link
                                      onClick={openModalServicios}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <item.icon
                                        className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                        aria-hidden="true"
                                      />

                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              ) : (
                                <>
                                  {servicios.map((item) => (
                                    <Link
                                      onClick={openModalServicios}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <>
                                        <item.icon
                                          className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                          aria-hidden="true"
                                        />
                                      </>
                                      {/*     )
                                        } */}

                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        onClick={openModalPagos}
                        className={classNames(
                          open ? "text-white" : "text-white",
                          "group bg-transparent rounded-md inline-flex items-center text-base font-medium  "
                        )}
                      >
                        <span>Pagos</span>
                        <ChevronDownIcon
                          className={classNames(
                            open ? "text-white" : "text-gray-400",
                            "ml-2 h-5 w-5 group-hover:text-white"
                          )}
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        appear
                        show={showPagos || false}
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {user?.datos?.tipoCliente !== "Empresa" ? (
                                <>
                                  {pagosResidecial.map((item) => (
                                    <Link
                                      onClick={openModalPagos}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <item.icon
                                        className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                        aria-hidden="true"
                                      />
                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              ) : (
                                <>
                                  {pagosEmpresarial.map((item) => (
                                    <Link
                                      onClick={openModalPagos}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <item.icon
                                        className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                        aria-hidden="true"
                                      />
                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        onClick={openModalFacturas}
                        className={classNames(
                          open ? "text-white" : "text-white",
                          "group bg-transparent rounded-md inline-flex items-center text-base font-medium  "
                        )}
                      >
                        <span>Facturas</span>
                        <ChevronDownIcon
                          className={classNames(
                            open ? "text-white" : "text-gray-400",
                            "ml-2 h-5 w-5 group-hover:text-white"
                          )}
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        show={showFacturas}
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {user?.datos?.tipoCliente === "Residencial" ? (
                                <>
                                  {facturas.map((item) => (
                                    <Link
                                      onClick={openModalFacturas}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <item.icon
                                        className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                        aria-hidden="true"
                                      />
                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              ) : (
                                <>
                                  {facturas.map((item) => (
                                    <Link
                                      onClick={openModalFacturas}
                                      key={item.name}
                                      to={item.href}
                                      className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                    >
                                      <item.icon
                                        className={`flex-shrink-0 h-[2rem] w-[2rem] text-[${colors.lightBlue}]`}
                                        aria-hidden="true"
                                      />
                                      <div className="ml-4">
                                        <p className="text-base font-medium text-gray-900">
                                          {item.name}
                                        </p>
                                        <p
                                          className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                        >
                                          {item.description}
                                        </p>
                                      </div>
                                    </Link>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        onClick={openModalReportes}
                        className={classNames(
                          open ? "text-white" : "text-white",
                          "group bg-transparent rounded-md inline-flex items-center text-base font-medium  "
                        )}
                      >
                        <span>Reportes</span>
                        <ChevronDownIcon
                          className={classNames(
                            open ? "text-white" : "text-gray-400",
                            "ml-2 h-5 w-5 group-hover:text-white"
                          )}
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        show={showReportes}
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {reportes.map((item) => (
                                <Link
                                  onClick={openModalReportes}
                                  key={item.name}
                                  to={item.href}
                                  className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                >
                                  <item.icon
                                    className={`flex-shrink-0 h-[1.5rem] w-[1.5rem] text-[${colors.lightBlue}]`}
                                    aria-hidden="true"
                                  />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-gray-900">
                                      {item.name}
                                    </p>
                                    <p
                                      className={`mt-1 text-sm text-[${colors.darkBlue}]`}
                                    >
                                      {item.description}
                                    </p>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
              </Popover.Group>
              <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0"></div>
            </>
          )}

          <Menu as="div" className="!m-0 hidden lg:block relative">
            {loading ? (
              <>
                <div className="flex animate-pulse flex-row-reverse items-center  gap-3 ">
                  <div className="flex-shrink-0">
                    <span className="w-[40px] h-[40px] block bg-gray-200 dark:bg-gray-600 rounded-full "></span>
                  </div>
                  <div className="w-full flex justify-between flex-col gap-2 items-center">
                    <li className="w-full h-3 bg-gray-200 dark:bg-gray-600  "></li>
                    <li className="w-full h-3 bg-gray-200 dark:bg-gray-600  "></li>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-end">
                  <Menu.Button
                    onClick={openModalPerfil}
                    className="bg-transparent flex gap-5 flex-row-reverse items-center text-sm rounded-full "
                  >
                    <span className="sr-only">Open user menu</span>
                    <div className="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-white rounded-full ">
                      <span
                        className={`font-medium text-[${colors.lightBlue}] `}
                      >
                        {user?.initial || "NA"}{" "}
                      </span>
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-left whitespace-nowrap font-medium text-white group-hover:text-gray-900">
                        {user?.datos?.nombreApellido}
                      </p>
                      <p className="text-xs font-medium text-end text-white group-hover:text-gray-700">
                        {user?.datos?.tipoCliente}{" "}
                      </p>
                    </div>
                  </Menu.Button>
                </div>
              </>
            )}

            <Transition
              show={showProfile}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      onClick={openModalPerfil}
                      to={"/cuenta/perfil"}
                      className={classNames(
                        active ? "bg-gray-100" : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    >
                      Ver perfil
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={exit}
                      className={classNames(
                        active ? "bg-gray-100" : "",
                        "w-full text-left block px-4 py-2 text-sm text-gray-700"
                      )}
                    >
                      Salir
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
          <div className="-mr-2 -my-2  md:hidden">
            <Popover.Button
              onClick={openModalResponsive}
              className="bg-transparent rounded-md p-2 inline-flex items-center justify-center text-white hover:text-white hover:bg-gray-100"
            >
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-8 w-8" aria-hidden="true" />
            </Popover.Button>
          </div>
        </div>

      </div>

      <Transition
        show={responsive}
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-8 w-auto" src={logoBlack} alt="Workflow" />
                </div>
                <div className="-mr-2"></div>
              </div>
              <div className="mt-6">

                <nav className="grid gap-y-8">
                  {user?.datos?.tipoCliente !== "Empresa" ? (
                    <>
                      {menuResposive.map((item, index) => (
                        <Link
                          onClick={openModalResponsive}
                          key={index}
                          to={item.href}
                          className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                        >
                          <item.icon
                            className={`flex-shrink-0 h-6 w-6 text-[${colors.lightBlue}]`}
                            aria-hidden="true"
                          />
                          <span className="ml-3 text-base font-medium text-gray-900">
                            {item.name}
                          </span>
                        </Link>
                      ))}
                    </>
                  ) : (
                    <>
                      {menuResponsiveCorporativo.map((item, index) => (
                        <Link
                          onClick={openModalResponsive}
                          key={index}
                          to={item.href}
                          className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                        >
                          <item.icon
                            className={`flex-shrink-0 h-6 w-6 text-[${colors.lightBlue}]`}
                            aria-hidden="true"
                          />
                          <span className="ml-3 text-base font-medium text-gray-900">
                            {item.name}
                          </span>
                        </Link>
                      ))}
                    </>
                  )}
                </nav>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default Header;
